import { dmnStorage } from "./dmnStorage";

/** "app" is the current Collins colours; "classic" is the colours of the old Collins. */
export type Palette = "app" | "classic";

const STORAGE_KEY = "palette";

export const DEFAULT_PALETTE: Palette = "app";

/** Anything stored that is not a known palette reads as the default. */
export const normalisePalette = (value: unknown): Palette =>
  value === "classic" ? "classic" : DEFAULT_PALETTE;

/** The palette chosen on this device (device storage; it does not follow the user between devices). */
export const getStoredPalette = async (): Promise<Palette> => {
  try {
    return normalisePalette(await dmnStorage.get(STORAGE_KEY));
  } catch {
    return DEFAULT_PALETTE;
  }
};

export const storePalette = async (palette: Palette): Promise<void> => {
  await dmnStorage.add(STORAGE_KEY, palette);
};

/** The page carries no palette at all (the feature is off). */
export const clearPalette = (): void => {
  document.body.removeAttribute("data-palette");
};

/** Put the palette on the page, where the stylesheet reads it. */
export const applyPalette = (palette: Palette): void => {
  if (palette === "classic") {
    document.body.setAttribute("data-palette", "classic");
  } else {
    clearPalette();
  }
};
